import { render, staticRenderFns } from "./IntervalReportByProduct.vue?vue&type=template&id=5c68a972"
import script from "./IntervalReportByProduct.vue?vue&type=script&lang=js"
export * from "./IntervalReportByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports